<template>
  <div>
    <breadcrumb-list>
      <breadcrumb-link view="Home" label="Home" />
      <breadcrumb-link view="AdminBlanketVOBList" label="Blanket VOB Search" />
      <breadcrumb-link
        v-if="blanketVOB"
        view="AdminBlanketVOBDetails"
        :label="pageTitle"
        :params="{ id: blanketVOB.id, payerResponseId: $route.params.payerResponseId }"
        :active="true"
      />
    </breadcrumb-list>

    <div v-if="blanketVOB">
      <BlanketVOBExpired
        v-if="isBlanketVOBExpired"
        :blanket-vob-id="blanketVOB.id"
        :created-at="blanketVOB.created_at"
      ></BlanketVOBExpired>

      <BlanketVOBDetailPlan
        v-else
        :blanket-vob="blanketVOB"
        :created-at="blanketVOB.created_at"
        :as-of-date="blanketVOB.created_at"
        :blanket_vob_id="blanketVOB.id"
        :provider="blanketVOB.provider.name"
        :payers="selectedPayer"
        details-route-name="AdminBlanketVOBDetails"
      ></BlanketVOBDetailPlan>
    </div>
  </div>
</template>

<script>
import BlanketVOBDetailPlan from '../../components/BlanketVOBDetailPlan.vue';
import BlanketVOBExpired from '../../components/BlanketVOBExpired.vue';
import request from '../../request';

export default {
  name: 'AdminBlanketVOBDetails',
  components: {
    BlanketVOBDetailPlan,
    BlanketVOBExpired,
  },
  computed: {
    pageTitle() {
      return this.blanketVOB?.full_name || this.blanketVOB?.id || '';
    },
    isBlanketVOBExpired() {
      if (!this.blanketVOB) return false;
      const twoMonthsAgo = new Date(Date.now() - 60 * 24 * 60 * 60 * 1000);
      return this.blanketVOB.created_at < twoMonthsAgo;
    },
    selectedPayer() {
      if (!this.blanketVOB || !this.$route.params.payerResponseId) {
        return [];
      }
      const payer = this.blanketVOB.blanket_vob_payers.find(
        (payer) => payer.id === this.$route.params.payerResponseId
      );
      return payer ? [payer] : [];
    },
  },
  data() {
    return {
      blanketVOB: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    request
      .get(`/admin/blanket-vob-search/${to.params.id}`)
      .then((resp) => {
        let status = resp.data.blanket_vob.status;
        if (status === 'complete' || status === 'error') {
          next((vm) => (vm.blanketVOB = resp.data.blanket_vob));
        } else {
          next({ name: 'NotFound' });
        }
      })
      .catch(() => {
        next({ name: 'NotFound' });
      });
  },
};
</script>
